import { useEffect, useMemo, useState } from "react";
import { Button, Drawer } from "antd";
import { ActiveFilterIconMobile, CloseIcon, FilterIconMobile } from "../assets/icon";
import { formatOptions } from "app/(new-pages)/components/allSelect/helper";
import styles from "../../../style/index.mobile.module.scss";
import classNames from "classnames";
import CollapseSingleSelect from "app/(new-pages)/components/allSelect/CollapseSingleSelect/mobile/index.mobile";

const FilterMobile = ({
  config,
  handleClearAll,
  reload,

  moreFilterData,
  setMoreFilterData,

  salary,
  setSalary
}) => {
  const {
    remote_only_text,
    filter_header_text,
    filter_apply_text,
    filter_reset_text,

    xp_lvl_filter,
    xp_lvl_text,

    degree_filter,
    degree_text,

    salary_filter,
    salary_text
  } = config;

  const salary_range_list = salary_filter?.[1]?.salary_range_list ?? [];

  const xpLvlOptions = formatOptions(xp_lvl_filter, []);
  const degreeOptions = formatOptions(degree_filter, []);
  const monthlySalaryOptions = formatOptions(salary_range_list, []);

  const [open, setOpen] = useState(false);

  const [cloneXpLvl, setCloneXpLvl] = useState(
    (moreFilterData.xp_lvl !== "" && moreFilterData.xp_lvl?.split(",")) || []
  );
  const [cloneDegree, setCloneDegree] = useState(
    (moreFilterData.degree !== "" && moreFilterData.degree?.split(",")) || []
  );
  const [cloneSalary, setCloneSalary] = useState({
    salary: salary.salary,
    salary_type: salary.salary_type
  });

  useEffect(() => {
    setCloneXpLvl((moreFilterData.xp_lvl !== "" && moreFilterData.xp_lvl?.split(",")) || []);
    setCloneDegree((moreFilterData.degree !== "" && moreFilterData.degree?.split(",")) || []);
    setCloneSalary({
      salary: salary.salary,
      salary_type: salary.salary_type
    });
  }, [open]);

  const activeCount = useMemo(() => {
    const count = [...cloneXpLvl, ...cloneDegree, ...cloneSalary.salary].filter(
      (item) => item !== ""
    ).length;
    return count;
  }, [cloneXpLvl, cloneDegree, cloneSalary]);

  const onClose = () => {
    setOpen(false);
  };

  const onApply = () => {
    reload();
    onClose();
  };

  const onClear = () => {
    onClose();
    handleClearAll();
  };

  const handleApply = () => {
    setMoreFilterData({
      company_financing_stage: "",
      company_size: "",
      degree: cloneDegree.join(",") ?? "",
      company_industry: "",
      xp_lvl: cloneXpLvl.join(",") ?? ""
    });
    setSalary(cloneSalary);

    onApply();
  };

  return (
    <>
      <div
        className={classNames({
          [styles.openFilter]: true
        })}
        onClick={() => setOpen(true)}
      >
        {activeCount ? <ActiveFilterIconMobile /> : <FilterIconMobile />}
        <span
          className={classNames({
            [styles.describe]: true,
            [styles.openFilterActive]: activeCount
          })}
        >
          {filter_header_text} {activeCount ? <span>{activeCount}</span> : null}
        </span>
      </div>

      <Drawer
        closeIcon={null}
        title={null}
        placement='bottom'
        onClose={onClose}
        open={open}
        height={"100%"}
        className={styles.drawer}
        destroyOnClose={true}
        afterOpenChange={(visible) => {
          document.body.style.overflow = visible ? "hidden" : "";
        }}
      >
        <div className={styles.drawerHeader}>
          <div className={styles.drawerHeaderTitle}>{filter_header_text}</div>

          <span onClick={onClose} className={styles.drawerClose}>
            <CloseIcon />
          </span>
        </div>

        <div className={styles.drawerMain}>
          <div className={styles.drawerMainBox}>
            <span>{remote_only_text}</span>
          </div>

          <CollapseSingleSelect
            options={degreeOptions}
            value={cloneDegree}
            onChange={setCloneDegree}
            label={degree_text}
          />

          <CollapseSingleSelect
            options={monthlySalaryOptions}
            value={cloneSalary.salary}
            onChange={(value) => {
              setCloneSalary({ salary: value, salary_type: "monthly" });
            }}
            label={salary_text}
          />

          <CollapseSingleSelect
            options={xpLvlOptions}
            value={cloneXpLvl}
            onChange={setCloneXpLvl}
            label={xp_lvl_text}
          />
        </div>

        <div className={styles.drawerFooter}>
          <div className={styles.drawerButtons}>
            <Button onClick={onClear}>{filter_reset_text}</Button>
            <Button type='primary' onClick={handleApply}>
              {filter_apply_text} {activeCount > 0 ? `(${activeCount})` : null}
            </Button>
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default FilterMobile;
